export {NEWLINE} from "./newline";
export {TAB} from "./tab";
export {REDO} from "./redo";
export {UNDO} from "./undo";

export {on} from "./core/on";
export {connectEvents} from "./core/connectEvent";